import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as signalR from "@microsoft/signalr";


export const hubConnectionStates = {
    /**
     * The hub connection is connected.
     */
    CONNECTED: "Connected",
    /**
     * The hub connection is connecting.
     */
    CONNECTING: "Connecting",

    /**
     *  The hub connection is disconnected.
     */
    DISCONNECTED: "Disconnected",
    /**
     * The hub connection is disconnecting.
     */
    DISCONNECTING: "Disconnecting",

    /**
     * The hub connection is reconnecting.
     */
    RECONNECTING: "Reconnecting"

};


/**
 * Connected user to signal are hub and manage connection.
 * @return hubConnection
 */
function useSignalR(connectionString, token = "") {
    const [hubConnection, setHubConnection] = useState(undefined);

    useEffect(() => {
        if (!connectionString || !token) {
            console.log("Can't create connection without url or token");
            return;
        }

        // create connection
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(connectionString, {
                skipNegotiation: true,
                transport: signalR.HttpTransportType.WebSockets,
                accessTokenFactory: () => token
            })
            .withAutomaticReconnect()
            .build();

        // DEBUGGING
        window.signalR = signalR;
        window.currentSignalRConnection = connection;
        window.connectionStates = hubConnectionStates;

        setHubConnection(connection);

        return () => {
            // clean up connection on dismount
            console.log("dismount or token changed");
            if (connection.state === signalR.HubConnectionState.Connected ||
                connection.state === signalR.HubConnectionState.Connecting
            ) {
                // TODO find out what happens when token changes. ()
                stopConnection();
            }
        };
    }, [connectionString, token]);


    const stopConnection = () => {
        if (hubConnection) hubConnection.stop();
        setHubConnection(undefined);
    };

    return hubConnection
}

useSignalR.propTypes = {
    connectionString: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired
};

useSignalR.defaultProps = {
    connectionString:  "",
    token: ""
};

export default useSignalR;
